import React from 'react';
import { PulsingBorder } from '@paper-design/shaders-react';

interface PulsingShift4LogoProps {
  size?: number;
  className?: string;
}

const PulsingShift4Logo: React.FC<PulsingShift4LogoProps> = ({
  size = 100,
  className = ''
}) => {
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      <PulsingBorder
        colors={["#136ef6", "#0d5dd1", "#0a4db3", "#136ef6"]}
        colorBack="#00000000"
        speed={0.8}
        roundness={1}
        thickness={0.15}
        softness={0.05}
        intensity={1.0}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: '50%',
          position: 'absolute',
          top: 0,
          left: 0
        }}
      />
      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{ zIndex: 1 }}
      >
        {/* Inline SVG with dark mode support */}
        <svg
          viewBox="0 0 109.83 188.44"
          className="mr-1 fill-black dark:fill-white"
          style={{
            width: '28%',
            height: '38%',
          }}
        >
          <path d="M91.59,1.07L.59,117.81c-.38.49-.59,1.1-.59,1.72v13.4c0,1.54,1.25,2.79,2.79,2.79h81.32c1.54,0,2.79,1.25,2.79,2.79h0v47.14c0,1.54,1.25,2.79,2.79,2.79h17.35c1.54,0,2.79-1.25,2.79-2.79h0V2.78C109.83,1.24,108.59,0,107.05,0c0,0,0,0-.01,0h-13.24c-.86,0-1.68.39-2.21,1.07ZM30.69,110.39l51.21-65.37c.94-1.22,2.69-1.45,3.91-.51.69.53,1.09,1.36,1.09,2.23v65.37c0,1.54-1.25,2.79-2.79,2.79h-51.22c-1.54,0-2.79-1.25-2.79-2.79,0-.62.21-1.23.59-1.72Z"/>
        </svg>
      </div>
    </div>
  );
};

export default PulsingShift4Logo;
